// source: pbtypes/gen/phone/advanced_setting.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.phone.AdvancedSetting', null, global);
goog.exportSymbol('proto.phone.AdvancedSetting.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.phone.AdvancedSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.phone.AdvancedSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.phone.AdvancedSetting.displayName = 'proto.phone.AdvancedSetting';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.phone.AdvancedSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.phone.AdvancedSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.phone.AdvancedSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.phone.AdvancedSetting.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.phone.AdvancedSetting}
 */
proto.phone.AdvancedSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.phone.AdvancedSetting;
  return proto.phone.AdvancedSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.phone.AdvancedSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.phone.AdvancedSetting}
 */
proto.phone.AdvancedSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.phone.AdvancedSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.phone.AdvancedSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.phone.AdvancedSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.phone.AdvancedSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.phone.AdvancedSetting.Enum = {
  UNKNOWN: 0,
  EXTREME_OBSTACLE_MARGIN: 2,
  DEV_RECORDING_MODES: 5,
  COCKPIT_ANALOG_SLIDER_CONTROLS: 7,
  MICROHARD: 8,
  LAND_AFTER_LOST_CONN_RTH: 9,
  GIMBAL_INSPECTION_MODE: 11,
  DISTANCE_TO_CONTROLLER: 12,
  MAPBOX: 13,
  ALLOW_NIGHT_FLIGHT: 14,
  HERELINK: 15,
  IOS_RECORD_AUDIO: 16,
  HEIGHT_CEILING_TOGGLE: 17,
  DEV_CAPTURE_SETTINGS: 19,
  DISABLE_PHONE_LOG_CULL: 20,
  ENABLE_NEW_LOG_UPLOAD_FLOW: 21,
  BRIDGE_ESTIMATION_MODE: 25,
  RETURN_VISION_ONLY_TOGGLE: 26,
  SUPERZOOM: 28,
  DIGITAL_ZOOM: 34,
  MOBILE_DEV_MENU: 30,
  ENABLE_MISSIONS: 35,
  EXTENDED_WAYPOINT_FLIGHT: 31,
  SKYDIOLINK_AES256: 32,
  VEHICLE_TELEOPERATION: 33,
  OFFLINE: 36,
  C78_CUSTOMIZE_VEHICLE_WIFI: 37,
  RGB_LED_DISABLE: 38,
  MOBILE_RUNMODE_SWITCHING: 39,
  SHOW_MODEL_VIEWER: 40,
  UCON_ENABLED_WITH_SIM: 41,
  PINCH_CUSTOMIZATION: 42,
  DOUBLE_TAP_TOGGLE: 43,
  UCON_MANAGEMENT: 44,
  ALLOW_SDCARD_OVERWRITE: 45,
  MOBILE_STREAMING: 46,
  CRASH_TESTING_MENU: 49,
  KEYFRAME_ENABLED: 50,
  SHOW_LANGUAGE_PREFERENCE: 51,
  CONTROLLER_UI_NAV: 52,
  MOBILE_LIVE_CLOUD_LINK: 53,
  C78_OS_UPDATE_ENABLED: 54,
  MOBILE_MERGE_LOCAL_VIDEO_PREVIEW: 55,
  ENABLE_SCOUT: 56,
  MOBILE_STREAMING_DATA_SAVER: 57,
  DYNAMIC_OBSTACLE_AVOIDANCE_ENABLED: 58,
  RTSP_STREAMING: 59,
  TAK_CONFIG_ENABLED: 60,
  RID_FEATURE_ENABLED: 61,
  ALLOW_VESSEL_MODE_FLIGHT: 62,
  THERMAL_ROI_ENABLED: 63,
  RF_HIGH_POWER_ENABLED: 64,
  USE_BACKTRACKING_RTX_TOGGLE: 65,
  ALLOW_ON_VEHICLE_PHOTOGRAMMETRY: 66,
  RID_FEATURE_DISABLED: 67,
  ENABLE_GEOFENCES: 68,
  FULL_FRAME_PHOTO_ENABLED: 69,
  COCKPIT3_ENABLED: 70,
  RANGEFINDING: 71,
  ALLOW_NIGHT_AUTONOMY: 72,
  SITE_MAPPER: 73,
  ALLOW_RAPID_DESCENT: 74,
  ENABLE_USER_CAMERA_TAP_TO_FOCUS: 75,
  GATE3_ENABLED: 76,
  MOBILE_THEME_SWITCHING_ENABLED: 77,
  FLIGHT_SCREEN_RECORD_ENABLED: 79,
  DISABLE_MH_2_4BAND: 81,
  CROSSHAIR_COORDINATES_ENABLED: 82,
  MOBILE_CELLULAR_TELEOP: 83,
  DPAD_ACTION_WHEEL_ENABLED: 84,
  ALLOW_3DS_ON_CELLULAR: 85,
  ALLOW_MEDIA_ENCRYPTION: 87,
  ALLOW_MEDIA_ENCRYPTION_V2: 137,
  ENABLE_M1_BAND: 88,
  ENABLE_PUBLIC_SAFETY_LIGHTS: 89,
  ENABLE_ATTITUDE_RTX: 90,
  ENABLE_MANUAL_WFF: 91,
  ENABLE_AR_OBSERVER_VIEW: 92,
  ENABLE_VEHICLE_GPS_TOGGLE: 93,
  ENABLE_ATTITUDE_TOGGLE: 94,
  ENABLE_C18D_ONLINE: 95,
  ENABLE_AXONRESPOND_UI: 96,
  ENABLE_MULTIVIEWERSTREAMING_UI: 97,
  ENABLE_MULTI_USER_CONTROLLER: 98,
  ENABLE_MAVLINK_UI: 99,
  ENABLE_LEGACY_LOG_SYNC_FLOW: 100,
  ENABLE_LINK_QUALITY_FEEDBACK: 101,
  EUROPEAN_UNION: 103,
  ALLOW_ES_LANGUAGE: 104,
  ALLOW_DE_LANGUAGE: 105,
  ALLOW_HI_LANGUAGE: 106,
  ALLOW_JA_LANGUAGE: 107,
  ALLOW_UK_LANGUAGE: 108,
  ALLOW_ZH_LANGUAGE: 109,
  ENABLE_FORCE_VIO_DEGRADED: 110,
  ENABLE_C18D_MICROHARD_OFFLINE_CONFIG: 111,
  DISABLE_LEGACY_ANALYTICS: 112,
  ENABLE_MOBILE_LOG_SYNC_DETAILS_MODAL_UI: 113,
  ENABLE_VEHICLE_LOG_EXPORT_TO_USBC: 114,
  ENABLE_C18_LOG_AUTOUPLOAD: 115,
  ENABLE_C18_KLV: 116,
  ENABLE_THIRD_PARTY_ATTACHMENT_PROTOTYPING: 117,
  ENABLE_C18_ADSB: 118,
  DISABLE_WIRELESS_INTERFERENCE_WARNINGS: 119,
  ENABLE_FORCE_LOW_TAKEOFF_TOGGLE: 120,
  ENABLE_MOBILE_LOG_SYNC_UPLOAD_STATUS: 121,
  ENABLE_EXTERNAL_RADIO_SETTING: 122,
  ENABLE_MOBILE_ORG_MARKERS: 123,
  ENABLE_PANORAMA_SKILL: 125,
  ENABLE_MOBILE_AR_STREET_OVERLAY: 126,
  ENABLE_AUDIBLE_BATTERY_ALERTS: 127,
  ENABLE_SPECTRAL_CHANNEL_PICKER_PINE: 128,
  DISABLE_C18_WIFI: 129,
  ENABLE_THIRD_PARTY_RADIO_ATTACHMENT: 130,
  ENABLE_MOBILE_MISSIONS_CLOUD_TO_CONTROLLER: 131,
  ENABLE_RESCUE_BUOY_DROPPER: 132,
  ENABLE_MOBILE_FLEET_HEALTH_ALERTS: 133,
  ENABLE_SLOW_MODE: 134,
  ENABLE_ISR_TELEMETRY: 135,
  ENABLE_AGL_TELEMETRY: 136,
  ENABLE_MOBILE_SETTINGS_REMOTE_ID_OPERATOR_ID: 138,
  ENABLE_SUBJECT_MAP_DISPLAY: 139,
  ENABLE_MOBILE_REFACTORED_CONTROLLER_OTA: 140,
  ENABLE_MAP_LAYERS: 141,
  ENABLE_C18_UNKIOSKING: 142,
  ENABLE_MOBILE_3D_MAP_STREAM: 143,
  ENABLE_MOBILE_INSPECTION_ASSETS: 144,
  ENABLE_MOBILE_A22_MULTI_SIM: 145,
  MISSION_PLANNER_AR_PILLAR: 146,
  ENABLE_USB_MODE_SELECT: 147,
  ENABLE_CONTROLLER_STATIC_IP: 148,
  ENABLE_DCS_MODE_SELECTION: 149,
  ENABLE_CONTROLLER_MISSION_PLANNING: 150,
  ENABLE_MOBILE_DTED_MANAGER: 151,
  ENABLE_MOBILE_PERSONNEL_MARKERS: 152,
  ENABLE_MOBILE_CUSTOM_MARKERS: 153,
  ENABLE_MOBILE_GUNSHOT_DETECTION_MARKERS: 154,
  ENABLE_MOBILE_ALPR_MARKERS: 155,
  ALLOW_R10_PAIRING: 156,
  ENABLE_MULTI_VEHICLE_PAIRING: 157,
  ENABLE_20_MPS_MAX_SPEED: 158,
  ENABLE_20_MPS_MAX_SPEED_WAYPOINTS_ONLY: 159,
  ENABLE_HDMI_SCREEN_MIRROR: 160,
  ENABLE_MOBILE_REFACTORED_VEHICLE_OTA: 161,
  ENABLE_BACKHAUL_V2: 162,
  ENABLE_MOBILE_MARKER_CREATION: 163,
  ENABLE_GEO_LOOKAT: 164,
  ENABLE_CONTROLLER_GEOFENCE_V2: 165
};

goog.object.extend(exports, proto.phone);
